import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Number } from 'react-nexusui'
import classnames from 'classnames'

import { formatClassNames } from '../../utilities'

function LabelWrap(props) {
  const {
    children,
    label,
    value,
    tip,
    multiline,
    place,
    disabled,
    tooltips
  } = props

  const formattedLabel = label.replace(/[()]/g, '')

  return (
    <div
      className={classnames("labeled-number-input", formatClassNames(formattedLabel), {"off" : value === -1}, {"disabled" : disabled})}
      data-tip={tip}
      data-multiline={multiline}
      data-place={place}
      data-tip-disable={tooltips}
    >
      <label className="number-input-label">{label}</label>
      {children}
    </div>
  );
}

class LabeledInput extends Component {
  render() {
    const {
        label,
        min,
        max,
        value,
        onChange,
        disabled,
        showTooltips
    } = this.props

    return (
      <LabelWrap
        label={label}
        tip={this.props['tip']}
        multiline={this.props['multiline']}
        place={this.props['place']}
        tooltips={!showTooltips}
        max={max}
        disabled={disabled}
        value={value}
      >
        <Number
          step = {1}
          size = {[60, 30]}
          min = {min}
          max = {max}
          value = {value}
          onChange = {onChange}
        />
      </LabelWrap>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    showTooltips: state.editorPreferences.showTooltips
  }
}

export default connect(mapStateToProps, null)(LabeledInput)
